module.exports = __webpack_public_path__ + "img/微信图片_20251028123256_211_595.a39011e4.jpg";